<template>
  <layout-content-vertical-nav :nav-menu-items="navMenuItems">
    <slot></slot>

    <!-- Slot: Navbar -->
    <template #navbar="{ isVerticalNavMenuActive, toggleVerticalNavMenuActive }">
      <div
        class="navbar-content-container"
        :class="{'expanded-search': shallShowFullSearch}"
      >
        <div style="width: 100% !important; position: absolute; left:0;right: 0; top: 0">
          <v-row>
            <v-col
              cols="9"
              style="width: 100% !important;"
              class="d-flex justify-space-between pb-0"
            >
              <div class="d-flex">
                <v-icon
                  v-if="$vuetify.breakpoint.mdAndDown"
                  class="ml-4"
                  @click="toggleVerticalNavMenuActive"
                >
                  {{ icons.mdiMenu }}
                </v-icon>
                <div class="pt-3">
                  <app-bar-periode-visu></app-bar-periode-visu>
                </div>
              </div>
              <div class="pt-3 d-none d-md-inline-flex d-lg-inline-flex">
                <h2 class="text-uppercase">
                  {{ nomEntreprise }}
                </h2>
              </div>
              <div class="pr-2 pt-3">
                <!--                    <app-bar-i18n></app-bar-i18n>-->
                <!--                            <app-bar-theme-switcher class="mx-4"></app-bar-theme-switcher>-->
                <app-bar-notification></app-bar-notification>
                <v-icon
                  color="error"
                  class="ml-2"
                  @click="logoutUser"
                >
                  fas fa-power-off
                </v-icon>
                <!--                  <app-bar-user-menu></app-bar-user-menu>-->
              </div>
            </v-col>
            <v-col
              class="pt-5"
              cols="3"
              style="color: white; background: black; width: 100% !important;"
            >
              <div class="d-flex align-center right-row pr-4">
                <!--                      <app-bar-i18n></app-bar-i18n>-->
                <!--          <app-bar-theme-switcher class="mx-4"></app-bar-theme-switcher>-->
                <!--                  <app-bar-notification></app-bar-notification>-->
                <app-bar-user-menu></app-bar-user-menu>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="9"
              style="background: #000000; height: 54px"
            >
            </v-col>
            <v-col
              cols="3"
              style="background: #FBD901; border-bottom: 1px solid #ffffff;"
            >
            </v-col>
            <v-col
              cols="12"
              style="background: #FBD901; border-bottom: 1px solid #ffffff; padding:0px !important;"
            >
              <app-bar-marquee></app-bar-marquee>
            </v-col>
          </v-row>
        </div>
      </div>
    </template>

    <!-- Slot: Footer -->
    <template #footer>
      <div class="d-flex justify-space-between">
        <span class="d-flex">
          <!--          <v-img-->
          <!--            height='auto'-->
          <!--            max-width='100px'-->
          <!--            :src="require(`@/assets/images/misc/canal.png`)"-->
          <!--            alt='img canal'-->
          <!--            class='mr-2'-->
          <!--          ></v-img>-->
          COPYRIGHT &copy; {{ new Date().getFullYear() }} <a
            href="https://themeselection.com"
            class="text-decoration-none"
          >SYGALIN SAS</a><span class="d-none d-md-inline">, Tous droits réservés</span></span>
        <!--        <div class="align-center d-none d-md-flex">-->
        <!--          <span>fait à la main &amp Fait avec le</span>-->
        <!--          <v-icon-->
        <!--            color="error"-->
        <!--            class="ms-2"-->
        <!--          >-->
        <!--            {{ icons.mdiHeartOutline }}-->
        <!--          </v-icon>-->
        <!--        </div>-->
      </div>
    </template>

    <!--    <template #v-app-content>-->
    <!--      <app-customizer class="d-none d-md-block"></app-customizer>-->
    <!--    </template>-->
  </layout-content-vertical-nav>
</template>

<script>
import LayoutContentVerticalNav from '@/@core/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import navMenuItems from '@/navigation/vertical'

// App Bar Components
// import AppBarSearch from '@core/layouts/components/app-bar/AppBarSearch.vue'
import appBarPeriodeVisu from '@core/layouts/components/app-bar/AppBarPeriodeVisu.vue'
import AppBarI18n from '@core/layouts/components/app-bar/AppBarI18n.vue'
import AppBarThemeSwitcher from '@core/layouts/components/app-bar/AppBarThemeSwitcher.vue'
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import AppBarNotification from '@core/layouts/components/app-bar/AppBarNotification.vue'
import { mdiMenu, mdiHeartOutline, mdiCalendarOutline } from '@mdi/js'

import { getVuetify, useRouter } from '@core/utils'

// Search Data
import appBarSearchData from '@/assets/app-bar-search-data'

import { ref, watch } from '@vue/composition-api'
import useDynamicConstant from '@/helpers/useDynamicConstant'
import Http from '@/helpers/http'
import Session from '@/helpers/session'

import AppBarMarquee from '@core/layouts/components/app-content-container/AppBarMarquee.vue'
import Storage from '@/helpers/storage'

export default {
  components: {
    LayoutContentVerticalNav,

    // App Bar Components
    // AppBarSearch,
    appBarPeriodeVisu,
    AppBarI18n,
    AppBarThemeSwitcher,
    AppBarUserMenu,
    AppBarNotification,
    AppBarMarquee,
  },
  setup() {
    const $vuetify = getVuetify()

    const { ENTERPRISE_NAME } = useDynamicConstant()

    const nomEntreprise = ENTERPRISE_NAME

    const { router } = useRouter()

    const userData = JSON.parse(Session.get('userData'))

    const { isSuperAdmin } = useDynamicConstant()

    const isAdminRole = isSuperAdmin(userData.roles[0].id)

    // Search
    const appBarSearchQuery = ref('')
    const shallShowFullSearch = ref(false)
    const maxItemsInGroup = 5
    const totalItemsInGroup = ref({
      pages: 0,
      files: 0,
      contacts: 0,
    })
    watch(appBarSearchQuery, () => {
      totalItemsInGroup.value = {
        pages: 0,
        files: 0,
        contacts: 0,
      }
    })
    const searchFilterFunc = (item, queryText, itemText) => {
      if (item.header || item.divider) return true

      const itemGroup = (() => {
        if (item.to !== undefined) return 'pages'
        if (item.size !== undefined) return 'files'
        if (item.email !== undefined) return 'contacts'

        return null
      })()

      const isMatched = itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1

      if (isMatched) {
        if (itemGroup === 'pages') totalItemsInGroup.value.pages += 1
        else if (itemGroup === 'files') totalItemsInGroup.value.files += 1
        else if (itemGroup === 'contacts') totalItemsInGroup.value.contacts += 1
      }

      return appBarSearchQuery.value && isMatched && totalItemsInGroup.value[itemGroup] <= maxItemsInGroup
    }

    // ? Handles case where in <lg vertical nav menu is open and search is triggered using hotkey then searchbox is hidden behind vertical nav menu overlaty
    const handleShallShowFullSearchUpdate = (isVerticalNavMenuActive, toggleVerticalNavMenuActive) => {
      if ($vuetify.breakpoint.mdAndDown && isVerticalNavMenuActive) {
        toggleVerticalNavMenuActive()
      }
    }

    const logoutUser = () => {
      // Remove userData from localStorage
      // ? We just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      Http.post('/sign-out')
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          Session.unset('accessToken')
          Session.unset('userData')

          localStorage.clear()
          router.push({ name: 'auth-login' })
        })
        .catch(error => { console.error('Erreur :', error) })
    }

    const clientInfo = Storage.isSet('clientInfo') ? JSON.parse(localStorage.getItem('clientInfo')) : null

    return {
      navMenuItems,
      handleShallShowFullSearchUpdate,

      // Search
      appBarSearchQuery,
      shallShowFullSearch,
      appBarSearchData,
      searchFilterFunc,
      nomEntreprise,
      logoutUser,
      clientInfo,
      isAdminRole,

      icons: {
        mdiMenu,
        mdiHeartOutline,
        mdiCalendarOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.navbar-content-container {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
  position: relative;
  background: #ffffff;
}

// ? Handle bg of autocomplete for blured appBar
.v-app-bar.bg-blur {
  .expanded-search {
    ::v-deep .app-bar-autocomplete-box div[role='combobox'] {
      background-color: transparent;
    }

    > .d-flex > button.v-icon {
      display: none;
    }

    // ===

    & > .right-row {
      visibility: hidden;
      opacity: 0;
    }

    ::v-deep .app-bar-search-toggler {
      visibility: hidden;
    }
  }
}
</style>
